import { useEffect, useState } from 'react';
import { api } from '../api';
import { RepairStage } from '../data/RepairStage';

export function useRepairStageList() {
    const [repairStageList, setRepairStageList] = useState<RepairStage[]>([]);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        api.repairStage()
            .then((resData) => {
                setLoading(false);
                setRepairStageList(resData);
            }).catch(() => {
                setLoading(false);
            });
    }, []);

    return {
        repairStageList,
        isLoading,
    };
}
